import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { empty } from 'rxjs/internal/observable/empty';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-payments-gateway-dashboard',
  templateUrl: './payments-gateway-dashboard.component.html',
  styleUrls: ['./payments-gateway-dashboard.component.scss']
})
export class PaymentsGatewayDashboardComponent implements OnInit, OnDestroy {

  gateway;
  providers;
  types;
  getGatewayInfoSubscription: Subscription;
  getProvidersSubscription: Subscription;
  getTypesSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private paymentsService: PaymentsService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getGatewayInfo();
    this.getProviders();
    this.getTypes();
  }

  public getGatewayInfo() {
    const internalId = this.activatedRoute.snapshot.params['gatewayid'];
    this.getGatewayInfoSubscription = this.paymentsService.getGatewayInfo(internalId).pipe(
      tap(o => this.gateway = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getProviders() {
    this.getProvidersSubscription = this.paymentsService.getProviders().subscribe(
      (res) => {
        this.providers = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getTypes() {
    this.getTypesSubscription = this.paymentsService.getTypes().subscribe(
      (res) => {
        this.types = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cash-register', 'gateways-page.gateway', '/payments/gateways', [new BRoute('gateways-page.payments', '/payments'), new BRoute('gateways-page.gateways', '/payments/gateways'), new BRoute('gateways-page.gateway')]));
  }

  ngOnDestroy() {
    if (this.getGatewayInfoSubscription) { this.getGatewayInfoSubscription.unsubscribe(); }
    if (this.getProvidersSubscription) { this.getProvidersSubscription.unsubscribe(); }
    if (this.getTypesSubscription) { this.getTypesSubscription.unsubscribe(); }
  }
}
